import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { AxiosError } from "axios";
import { logger } from "core/logger";
import { appInsights } from "core/logger/ApplicationInsightsService";

export const reportLogger = (error: AxiosError) => {
    logger?.error('Report Error: ', error);
    appInsights?.trackException({ error, severityLevel: SeverityLevel.Error });
}